var _g, _rect, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBenefitCardSkyblue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 106,
    viewBox: "0 0 210 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_571_9539)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.400024,
    width: 209.6,
    height: 107,
    rx: 16,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.74 73.6463C241.124 67.6504 236.131 62.567 230.172 58.8149C224.213 55.0627 217.458 52.7492 210.465 52.0649C203.471 51.3805 196.439 52.3449 189.947 54.8786C183.455 57.4123 177.689 61.4428 173.125 66.6381C168.56 71.8335 165.327 78.045 163.692 84.7611C162.056 91.4771 162.066 98.5055 163.72 105.267C165.373 112.029 168.623 118.331 173.202 123.654C177.781 128.977 183.558 133.168 190.058 135.883L198.164 116.353C194.817 114.955 191.842 112.797 189.483 110.055C187.125 107.314 185.451 104.068 184.6 100.586C183.748 97.1033 183.743 93.4835 184.585 90.0246C185.427 86.5657 187.092 83.3666 189.443 80.6909C191.794 78.0152 194.764 75.9394 198.107 74.6345C201.451 73.3295 205.073 72.8329 208.675 73.1853C212.276 73.5378 215.755 74.7293 218.824 76.6617C221.893 78.5942 224.465 81.2122 226.327 84.3002L244.74 73.6463Z",
    fill: "#0089DE",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.017 23.2423C99.658 1.83642 106.654 -25.3398 127.642 -37.4575C148.631 -49.5752 175.664 -42.0456 188.023 -20.6397C200.381 0.766219 193.386 27.9425 172.397 40.0602C151.409 52.1778 124.375 44.6482 112.017 23.2423ZM169.592 -9.9988C163.227 -21.0233 149.304 -24.9012 138.495 -18.6604C127.685 -12.4195 124.082 1.57691 130.447 12.6014C136.812 23.626 150.735 27.5039 161.545 21.263C172.354 15.0221 175.957 1.02573 169.592 -9.9988Z",
    fill: "#0089DE",
    fillOpacity: 0.08
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.900024,
    y: 0.5,
    width: 208.6,
    height: 106,
    rx: 15.5,
    stroke: "url(#paint0_linear_571_9539)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.900024,
    y: 0.5,
    width: 208.6,
    height: 106,
    rx: 15.5,
    stroke: "#CCF5FD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_571_9539",
    x1: 9.10212,
    y1: 5.40019,
    x2: 199.267,
    y2: 114.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_571_9539"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.400024,
    width: 209.6,
    height: 107,
    rx: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefitCardSkyblue);
export default __webpack_public_path__ + "static/media/benefitCardSkyblue.33852a89017ce4f1b36bf1d4faa8a90e.svg";
export { ForwardRef as ReactComponent };